import { Text } from '@mantine/core';
import { CustomerFundDataTransaction } from '../types';

export const isFundTransfer = (transaction: CustomerFundDataTransaction) =>
  transaction.type === 'transfer in' || transaction.type === 'transfer out';

export default function FundTransferDetails({ transaction }: { transaction: CustomerFundDataTransaction }) {
  if (!isFundTransfer(transaction)) return <>—</>;
  const incoming = transaction.type === 'transfer in';
  return <>
    <Text size="sm">
      {transaction.counterparty_crm_id
        ? `${incoming ? 'From' : 'To'} CRM ${transaction.counterparty_crm_id}`
        : `${incoming ? 'Sender' : 'Recipient'} not recorded`}
    </Text>
    {transaction.code && <Text size="xs" c="dimmed">Class: {transaction.code}</Text>}
    {transaction.geneva_transfer_id !== undefined &&
      <Text size="xs" c="dimmed">Geneva transfer #{transaction.geneva_transfer_id}</Text>}
  </>;
}
